import $ from 'jquery';
import 'bootstrap';
import menu from './utils/menu';
import modal from './utils/modal';
import common from './utils/common';
import scroll from './utils/scroll';
import landing from './pages/landing';


export const mobile = {state: false};



window.addEventListener("load", () => {

    common.init();
    menu.init();
    modal.init();
    window.scrollTo(0, 0);

    common.getWINDOW();
    if (common.$windowW < 768) {
        mobile.state = true;
    } else {
        mobile.state = false;
    }


    const waitForScrollReset = () => {
        const scrollY = scroll.lenis ? scroll.lenis.actualScroll : window.scrollY;

        if (scrollY === 0) {
            scroll.show();
            landing.init();
        } else {
            requestAnimationFrame(waitForScrollReset);
        }
    };

    waitForScrollReset();
});



$(document).ready(function () {

    // Gestion de la redimension de la fenêtre
    $(window).on("debouncedresize", function () {
        common.getWINDOW();
        if (common.$windowW <= 768 && mobile.state === false) {
            location.reload();
            mobile.state = true;
        } else if (common.$windowW > 768 && mobile.state === true) {
            location.reload();
            mobile.state = false;
        }
    });
});
